import { Search } from "../icons.js";
import { usePalette } from "./palette-context.js";
import "./palette-trigger.css";
import { shortcutLabel } from "./platform.js";

/** The top bar's way into "Jump to", for anyone who does not know the shortcut yet. */
export function PaletteTrigger() {
  const palette = usePalette();
  if (palette === null) return null;
  return (
    <button
      type="button"
      className="palette-trigger"
      aria-keyshortcuts="Meta+K Control+K"
      onClick={palette.open}
    >
      <Search className="palette-trigger-icon" aria-hidden="true" />
      <span>Jump to</span>
      <kbd className="palette-kbd">{shortcutLabel()}</kbd>
    </button>
  );
}
